import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["start", "end"]

  connect() {
    if (!this.hasStartTarget || !this.hasEndTarget) return

    this.startTarget.addEventListener("change", this.setMinOnEndDate.bind(this))

    this.endTarget.addEventListener("focus", this.fillEndDateIfBlank.bind(this))

    this.startTarget.addEventListener("click", this.checkCalendarState.bind(this))
    this.endTarget.addEventListener("click", this.checkCalendarState.bind(this))  
  }

  checkCalendarState(e) {
    if (window.flatpickrInstances?.["header"]) {
      const flatpickrInstance = window.flatpickrInstances["header"]
      if (flatpickrInstance.hasUser) {
        flatpickrInstance.open();
        e.preventDefault()
        return
      }
    }
  }

  setMinOnEndDate(event) {
    const startValue = event.target.value
    if (startValue) {
      this.endTarget.min = startValue
    }
  }

  fillEndDateIfBlank() {
    if (!this.endTarget.value && this.startTarget.value) {
      this.endTarget.value = this.startTarget.value
      this.endTarget.min   = this.startTarget.value
    }
  }
}
